import { VesselSuperType } from '../../models/vessels/all-ship-types';
import type {
  VesselSource,
  VesselV2FormItem,
} from '../../models/vessels/vessel.model';

export const MAXIMUM_FLEET_SIZE = 6000;

export interface PatchFleetsVesselsResponse {
  headers: {
    'Access-Control-Allow-Origin': string;
    'Content-Type': string;
  };
  statusCode: number;
  body: PatchFleetsVesselsResponseBody;
}
export interface PatchFleetsVesselsResponseBody {
  vessels_added: number | null;
  vessels_deleted: number | null;
}

export interface AmendFormikVals {
  replaceFleetVessels: boolean;
  vessels: VesselV2FormItem[];
}

export interface CreateFormikVals {
  isCompanyList: boolean;
  vessels: FleetsFormItem[];
}

export enum VesselListOwnershipType {
  Personal = 'personal',
  Company = 'company',
}

export enum VesselListOwnershipText {
  Personal = 'Personal Fleets',
  Company = 'Company Fleets',
}

export enum AmendVesselTab {
  Add = 'Add Vessel',
  Remove = 'Remove Vessel',
  Search = 'Search Vessel',
}

export enum FleetType {
  Static = 'static',
  Dynamic = 'dynamic',
}

export interface SelectedFleet {
  listName: string;
  selectedList: FleetsListData;
  vessels: FleetsVessel[];
}

export interface FleetsVessel {
  name?: string;
  flag?: string;
  vessel_id: string;
  vessel_list_id: string | string[];
  imo?: number | string;
  mmsi: number | string;
  heading?: number;
  latitude?: number;
  longitude?: number;
  callsign?: string;
  vessel_sub_type?: string;
  vessel_super_type?: string;
  course?: number;
  speed?: number;
  source: VesselSource;
  timestamp?: string | number;
}

export type NormalisedFleetsVessels = {
  byId: Record<string, FleetsVessel>;
  idsByImoMmsi: Record<string, string[]>;
  allIds: FleetsVessel['vessel_id'][];
};

export interface ExactMatchingVessel {
  mmsi: number;
  imo: number;
}

type VesselSourceFilter = {
  ais: boolean;
  riskIntelligence: boolean;
};

type FleetsVesselMinimal = {
  name: string;
  imo: string;
  mmsi: string;
};

export type FleetVesselInfo = {
  imo: string;
  current_mmsi: string;
  vessel_name: string;
  vessel_type: string;
  vessel_id?: string;
};

export interface FleetsVesselFilter extends FleetsVesselMinimal {
  shipType?: VesselSuperType;
}

export interface FleetsVesselBasic extends FleetsVesselFilter {
  flag?: string;
  name: string;
  mmsi: string;
  imo: string;
  callsign?: string;
}

export interface FleetVessel {
  shipType?: VesselSuperType;
  flag?: string | null;
  name?: string | null;
  mmsi?: string | null;
  imo: string;
  callsign?: string | null;
  current_mmsi?: string | null;
  vessel_name?: string | null;
  vessel_type?: string | null;
  vessel_id?: string | null;
}

export type FleetsListVessel = {
  current_mmsi: string;
  imo: string;
  vessel_id: string;
  vessel_list_id: string[];
  vessel_name: string;
  vessel_type: VesselSuperType;
};

export type FleetsListResponse = {
  [vesselListId: string]: {
    list_name: string;
    is_company_list: boolean;
    vessels: FleetsListVessel[];
    is_dynamic_list: false;
    description: null;
    filters: null;
  };
};

export type FleetsListData = {
  description: string | null;
  filters: {
    shipTypes?: VesselSuperType[] | null;
    flags?: string[] | null;
  } | null;
  is_dynamic_list: boolean;
  vessel_list_id: string;
  list_name: string;
  is_company_list: boolean;
  vessels: FleetsListVessel[];
};

export type FleetsFilters = {
  vesselSource: VesselSourceFilter;
  search: string;
  open: boolean;
  vesselListsVessels: FleetsVesselFilter[];
};

export interface FleetVisibility {
  visible: boolean;
  list: FleetsListData;
}

export interface FleetsFormItem {
  mmsi?: string;
  imo?: string;
}

export interface CsvFile {
  name: string;
  data: any[];
  error: boolean;
  loading: boolean;
  success: boolean;
}
